import { initials } from './initials';

/** A person's initials on their color. */
export function Avatar({ name, color, size = 28, title }: { name: string; color: string; size?: number; title?: string }) {
  return (
    <span className="avatar" title={title ?? name} style={{ background: color, width: size, height: size, fontSize: size * 0.42 }}>
      {initials(name)}
    </span>
  );
}
